import { useOutletContext } from "react-router-dom";

export type EnvironmentDetailsOutletContext = {
    showingAgentConversation: boolean;
};

export function useEnvironmentDetailsOutletContext() {
    return useOutletContext<EnvironmentDetailsOutletContext>();
}
